import { Link, Outlet } from "react-router";
import { assets } from "~/assets";

export default function LoginWrapper() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <Link to="/" className="mb-10 self-center">
        <img src={assets["./logos/logo.svg"]!} alt="CaboCheck Logo" className="h-10" />
      </Link>
      <Outlet />
    </div>
  );
}
